var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "image-news" },
    [
      _c(
        "el-carousel",
        { attrs: { height: "289px", interval: 15000, arrow: "never" } },
        _vm._l(_vm.list, function (item) {
          return _c("el-carousel-item", { key: item.id }, [
            _c(
              "div",
              { staticClass: "image-news-item" },
              [
                _c(
                  "Link",
                  {
                    staticClass: "img-link",
                    attrs: { to: item.url, target: "_blank" },
                  },
                  [
                    _c("img", {
                      staticClass: "link-item",
                      attrs: { alt: item.title, src: item.adImage },
                    }),
                  ]
                ),
                _c(
                  "p",
                  { staticClass: "image-news-title pl-10" },
                  [
                    _c(
                      "Link",
                      {
                        staticClass: "title-link text-cut",
                        attrs: { to: item.url, target: "_blank" },
                      },
                      [_vm._v(_vm._s(item.title))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }